export const LOCALE_COOKIE_NAME = 'locale';

// Get the preferred locale from cookie
export const getPreferredLocale = () => {
  if (typeof window === 'undefined') return null;
  
  const cookies = document.cookie.split(';');
  const localeCookie = cookies.find(cookie => 
    cookie.trim().startsWith(`${LOCALE_COOKIE_NAME}=`)
  );
  
  return localeCookie ? localeCookie.split('=')[1] : null;
};

// Set the preferred locale in cookie
export const setPreferredLocale = (locale) => {
  if (typeof window === 'undefined') return;
  
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1); // 1 year expiration
  
  // Set domain based on environment
  const hostname = window.location.hostname;
  const domainPart = hostname.includes('dropbox.com') ? '; domain=.dropbox.com' : '';
  
  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; expires=${expirationDate.toUTCString()}; path=/${domainPart}`;
  
  console.log(`Locale cookie set: ${locale} (domain: ${hostname.includes('dropbox.com') ? '.dropbox.com' : 'current'})`);
};

// Debug function to see all cookies
export const debugAllCookies = () => {
  if (typeof window === 'undefined') return;
  
  console.log('=== ALL COOKIES ===');
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie, index) => {
    const [name, value] = cookie.trim().split('=');
    console.log(`${index + 1}. ${name} = ${value}`);
  });
  console.log('==================');
};